import { usePracticeChats } from "../../../context/PracticeChatsContext";

// Thin wrapper kept for call-site clarity — the actual poll and ring/dismiss
// state live in PracticeChatsContext, shared across every consumer so an
// incoming call rings once and dismissing it hides it everywhere.
export function useIncomingCall() {
  const { incomingCall, dismissIncomingCall } = usePracticeChats();
  return { incoming: incomingCall, dismiss: dismissIncomingCall };
}
